import { Link, Outlet } from "react-router-dom";
import React from "react";
import Navbar from "../components/Navbar";
import { Toaster } from "react-hot-toast";
import Footer from "../components/Footer";
import { Fab } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";

const Layout = () => {
  return (
    <>
      <Toaster />
      <Navbar></Navbar>
      <main className="relative">
        <Outlet />
        <div className="fixed bottom-5 right-5 z-50">
          <Link to="/chat">
            <Fab size="secondary" color="secondary">
              <ChatIcon />
            </Fab>
          </Link>
        </div>
      </main>
      <Footer></Footer>
    </>
  );
};

export default Layout;
